// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3ugOx","newExpiryDate":"styles_newExpiryDate__15Voq","footer":"styles_footer__dhWbM"};